import { isHttpError } from "../api-client";

/**
 * Determines if an error should be retried.
 *
 * Retryable: Network errors, 5xx server errors, 429 rate limiting
 * Non-retryable: 4xx client errors (validation, auth, etc.)
 */
export function shouldRetry(failureCount: number, error: Error): boolean {
  if (failureCount >= 3) return false;
  if (!isHttpError(error)) return true;
  const status = error.status;
  return status >= 500 || status === 429;
}

/**
 * Calculates retry delay with exponential backoff.
 * Delay: 1s -> 2s -> 4s, capped at 8s
 */
export function getRetryDelay(attemptIndex: number): number {
  return Math.min(1000 * Math.pow(2, attemptIndex), 8000);
}
